import { render } from "./project_anchor_tag.vue?vue&type=template&id=e3bf477a"
import script from "./project_anchor_tag.vue?vue&type=script&lang=js"
export * from "./project_anchor_tag.vue?vue&type=script&lang=js"

import "./project_anchor_tag.vue?vue&type=style&index=0&id=e3bf477a&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__